export default __webpack_public_path__ + "static/erik-d8ff69f4655ae002bb226a8a09e3cbbf.png";